module.exports = __webpack_public_path__ + "img/green-circle-table-10.be2514ac.png";